import { API, graphqlOperation } from "aws-amplify";
import { deleteEndorsement, deletePost, deleteReport, deleteSkill as deleteSkillMutation } from "../graphql/mutations";
import getUserPosts from "./getUserPosts";
import deleteReports from "./deleteReports";

export default async function delete_post(user, id) {
    await deleteReports(user, id);
    await API.graphql(graphqlOperation(deletePost, { input: { id } }));
}
